import {CallToActionFunc, ISpecificSafezoneObject, ReadyFunc} from "./safezone-object-factory.service.interface";

export interface ISafezoneService {
  readonly hasError: boolean;
  reconnectToSafezone():void;
  openFullSafezone():void;
  readonly isEnabled: boolean;
}

export interface ISafezoneContext{
  userInfo: string,
  brandId: number,
  subBrandId: number,
  productPackage: number,
  systemId: number,
  lang: string,
  clientPlatform: string,
  clientVersion: string,
  locale: string,
  fontDomain: string,
}

export interface ISafezoneInitParams{
  context: ISafezoneContext,
  onReady: ReadyFunc,
  onError(error: string): void,
  onCallToAction: CallToActionFunc,
}

export interface ISafezoneHandler{
  closedFromSafezone:boolean;
  init(safezoneObj:ISpecificSafezoneObject):void,
  onReady():void;
  resetOnLogout():void
}

export interface IFullSafezoneHandler extends ISafezoneHandler{
  openFullSafezone(source?:OPEN_SAFEZONE_SOURCE_VALUES, correlationId?:string):void
}

export interface IMiniSafezoneHandler extends ISafezoneHandler{
  closeMiniSafezone():void,
  correlationID: string;
}

export const SAFEZONE_FUNCTION: string = "SafeZone";

export enum SAFEZONE_CONTAINERS_ID{
  FULL_SAFEZONE_CONTAINER_ID = "FullSafeZoneContainer",
  MINI_SAFEZONE_CONTAINER_ID = "MiniSafeZoneContainer"
}

export enum COMPONENT_NAMES{
  FULL = "FullSafeZone",
  MINI = "MiniSafeZone"
}


export const OPEN_SAFEZONE_SOURCE: string = "OpenSafeZoneSource"; // window.OpenSafeZoneSource
export enum OPEN_SAFEZONE_SOURCE_VALUES {
  LOBBY = "Lobby",
  USER_AREA = "UserArea"
}

export enum CHANNEL {
  LOBBY = "lobby",
  MINI = "mini"
}

export const CLOSE_SAFEZONE_SOURCE: string = "CloseSafeZoneSource";
export enum CLOSE_SAFEZONE_SOURCE_VALUES {
  CLIENT = "ClientPage",
  MINI_SZ = "MiniSafeZone"
}

export interface ICallToActionParams {
    actionId: number;
    url?: string;
}

export const ACTIONS = {
  OPEN_FULL: 66,
  CLOSE_FULL: 67,
  OPEN_EXTERNAL_LINK: 27,
  OPEN_RESPONSIBLE_GAMING: 69,
  OPEN_CONTACT_US: 70,
  LOG_OUT:71, // @TODO: is this used by RG or not? Based on their CallToAction definition, this doesn't exists
  KICK_OUT: 68
};

export const SAFEZONE_EVENTS = {
  MINI_OPEN: "sz_mini_open", //01010101
  MINI_READY: "sz_mini_ready",
  MINI_CLOSE_INTERNAL: "sz_mini_close_internal",
  MINI_CLOSE_EXTERNAL: "sz_mini_close_external", //01010104
  FULL_OPEN: "sz_full_open", //01020101
  FULL_READY: "sz_full_ready",
  FULL_CLOSE_EXTERNAL: "sz_full_close_external", //01020104
  CATEGORY_MINI: "mini",
  CATEGORY_FULL: "full"
};


